var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    { staticClass: "password-reset-text-box" },
    [
      _c(
        "b-input-group",
        [
          _c(
            "b-input-group-text",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.indicatorText !== "",
                  expression: "indicatorText !== ''"
                }
              ],
              class: "password-strength-indicator " + _vm.indicatorClass,
              attrs: { slot: "append" },
              on: {
                click: function($event) {
                  return _vm.clickStrengthIndicator()
                }
              },
              slot: "append"
            },
            [
              _vm._v(
                "\n            " + _vm._s(_vm.indicatorText) + "\n        "
              )
            ]
          ),
          _vm._v(" "),
          _c("b-form-input", {
            ref: "passwordInput",
            attrs: {
              id: _vm.inputId,
              maxlength: _vm.maxlength,
              disabled: _vm.disabled,
              name: _vm.name,
              placeholder: _vm.placeholder,
              required: _vm.required,
              state: null,
              "aria-label": _vm.ariaLabel,
              type: "password"
            },
            model: {
              value: _vm.password,
              callback: function($$v) {
                _vm.password = $$v
              },
              expression: "password"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0abb194e", { render: render, staticRenderFns: staticRenderFns })
  }
}